export interface BinaryDownloadModalOption {
  value: string;
  name: string;
}

export interface DiplomatAblePluginOption {
  id: string;
  name: string;
}

export const OPERATING_SYSTEM_OPTIONS: BinaryDownloadModalOption[] = [
  { value: 'linux', name: 'Linux' },
  { value: 'darwin', name: 'macOS' },
  { value: 'windows', name: 'Windows' },
];

export const PLATFORM_ARCHITECTURE_OPTIONS: BinaryDownloadModalOption[] = [
  { value: 'amd64', name: 'AMD64' },
  { value: 'arm64', name: 'ARM64' },
  { value: 'arm', name: 'ARM (legacy)' }, // Backwards compatibility - can be removed after envoy-web deploys
  { value: '386', name: '386' },
];

// Valid OS/architecture combinations that are actually supported
// Must match VALID_COMBINATIONS in envoy-web/app/services/diplomat_client_resolver.rb
export const VALID_COMBINATIONS: Array<[string, string]> = [
  ['linux', 'amd64'],
  ['linux', 'arm64'],
  ['linux', 'arm'], // Legacy - maps to arm64 on backend
  ['linux', '386'],
  ['darwin', 'amd64'],
  ['darwin', 'arm64'],
  ['windows', 'amd64'],
  ['windows', '386'],
];
